module.exports = __webpack_public_path__ + "static/hamburger-30f99272d8e18d2343cf64e2d18aa3df.jpg";